'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.remove = remove;
exports.add = add;
exports.clearAdd = clearAdd;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zfc on 2016/8/30.
 */

var LOAD = 'goeasy-crafts/attentionShop/LOAD';
var LOAD_SUCCESS = 'goeasy-crafts/attentionShop/LOAD_SUCCESS';
var LOAD_FAIL = 'goeasy-crafts/attentionShop/LOAD_FAIL';

var ADD = 'goeasy-crafts/attentionShop/ADD';
var ADD_SUCCESS = 'goeasy-crafts/attentionShop/ADD_SUCCESS';
var ADD_FAIL = 'goeasy-crafts/attentionShop/ADD_FAIL';

var REMOVE = 'goeasy-crafts/attentionShop/REMOVE';
var REMOVE_SUCCESS = 'goeasy-crafts/attentionShop/REMOVE_SUCCESS';
var REMOVE_FAIL = 'goeasy-crafts/attentionShop/REMOVE_FAIL';

var CLEARADDINFO = 'goeasy-crafts/attentionShop/CLEARADDINFO';

var initialState = {
  loaded: false
};

/*
 function analysisAddData(data, result) {
 let isValid = false;
 let errorMsg = '';
 if (result.addToAttentionError) {
 isValid = false;
 errorMsg = result.addToAttentionError;
 } else {
 isValid = true;
 errorMsg = '';
 }
 return {
 ...data,
 isValid,
 errorMsg
 };
 }
 */

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case ADD:
      return (0, _extends3.default)({}, state, {
        adding: true
      });
    case ADD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        adding: false,
        added: true,
        addData: action.result
        // analysisAddData(state.addData, action.result)
      });
    case ADD_FAIL:
      return (0, _extends3.default)({}, state, {
        adding: false,
        added: false,
        error: action.error
      });
    case REMOVE:
      return (0, _extends3.default)({}, state, {
        removing: true
      });
    case REMOVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        removing: false,
        removed: true,
        removeData: action.result
      });
    case REMOVE_FAIL:
      return (0, _extends3.default)({}, state, {
        removing: false,
        removed: false,
        error: action.error
      });
    case CLEARADDINFO:
      return (0, _extends3.default)({}, state, {
        addData: null
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.productListPage && globalState.productListPage.loaded;
}

function load(filter, page) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/attentionShop', {
        data: {
          type: 'getData',
          filter: filter,
          page: page
        }
      });
    }
  };
}

function remove(productId) {
  return {
    types: [ADD, ADD_SUCCESS, ADD_FAIL],
    promise: function promise(client) {
      return client.post('/attentionShop', {
        data: {
          type: 'remove',
          productId: productId
        }
      });
    }
  };
}

function add(shopId) {
  return {
    types: [ADD, ADD_SUCCESS, ADD_FAIL],
    promise: function promise(client) {
      return client.post('/attentionShop', {
        data: {
          type: 'add',
          shopId: shopId
        }
      });
    }
  };
}

function clearAdd() {
  return {
    type: CLEARADDINFO
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/attentionShop.js
 ** module id = 152
 ** module chunks = 0
 **/